import React, { FC } from 'react';

type TProfileHeader = {
  title: string;
  color?: string;
  icon?: React.ReactNode;
};

const ProfileHeader: FC<TProfileHeader> = props => {
  const { title, icon } = props;
  return (
    <div className="flex items-center gap-2">
      {icon && <span className="text-secondary">{icon}</span>}
      <h2 className="font-semibold text-xl md:text-2xl align-middle text-primary">
        {title}
      </h2>
    </div>
  );
};

export { ProfileHeader };
